import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Seo } from "../components/Seo";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="bg-boutique flex min-h-screen items-center justify-center px-4" data-testid="admin-login-page">
      <Seo title="Admin Login — Anaya Fashion & Gifts" path="/admin/login" noindex />
      <form onSubmit={submit} className="glass-deep w-full max-w-sm rounded-3xl p-8 shadow-2xl">
        <div className="text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary text-white"><Lock size={22} /></span>
          <h1 className="mt-4 font-display text-2xl">Owner sign in</h1>
          <p className="mt-1 text-xs font-light text-muted-foreground">Anaya boutique admin</p>
        </div>
        <label className="mt-6 block">
          <span className="text-xs tracking-[0.2em] text-muted-foreground uppercase">Email</span>
          <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="mt-1.5 w-full rounded-xl border border-input bg-white/80 px-4 py-3 text-sm outline-none focus:ring-1 focus:ring-primary" />
        </label>
        <label className="mt-4 block">
          <span className="text-xs tracking-[0.2em] text-muted-foreground uppercase">Password</span>
          <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-1.5 w-full rounded-xl border border-input bg-white/80 px-4 py-3 text-sm outline-none focus:ring-1 focus:ring-primary" />
        </label>
        {error && <p className="mt-4 rounded-xl bg-destructive/10 px-4 py-2.5 text-xs text-destructive" data-testid="admin-login-error">{error}</p>}
        <button type="submit" data-testid="admin-login-submit" disabled={loading}
          className="mt-6 w-full rounded-full bg-foreground py-3 text-xs font-medium tracking-[0.2em] text-white uppercase transition-colors hover:bg-primary disabled:opacity-50">
          {loading ? "Signing in..." : "Sign in"}
        </button>
        <Link to="/" className="mt-4 block text-center text-xs text-muted-foreground hover:text-primary" data-testid="admin-back-home">Back to the boutique</Link>
      </form>
    </div>
  );
}
